import React, { Component } from "react";
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row, Button, Modal, Card, CardHeader } from "reactstrap";
import { Form } from "@availity/form";
import '@availity/yup';
import { Redirect } from 'react-router-dom';
import axios from "axios";

import awardeestore from '../stores/awardeestore';
import CustomProgressBar from "../../Common/components/CustomProgressBar";
import ReviewSubmitContent from "./ReviewSubmitContent";
import commonStore from "../../Common/stores/commonStore";

@observer
export default class ReviewAndSubmit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToAcknowledgements: false,
      redirectPage: ''
    }

    if (awardeestore.getAwardeeHousingPageStatus('#reviewAndSubmit') !== 'stepwizard-step active') {
      awardeestore.setAwardeeHousingPageStatus('#reviewAndSubmit', 'active');
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
                awardeestore.resetAwardeeHousingPageStatus();
				window.location.href = '#';
			}
		}
  }

    printPage = () => {
        const content = document.querySelector("#reviewAndSubmitContent");
        const pri = document.querySelector("#ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    }

    handleSubmit = () => {
        const { history } = this.props;
        const postUrl = '/ahahawardeeprofileform/wa/api/v1/provconn/survey/tpa/submit';
        const data = awardeestore.getAhahFormData();
        awardeestore.turnOnBlocking();
        axios({
            method: 'post',
            url: postUrl,
            data: data
        }).then(res => {
            if(res.status === 200 && res.data.confirmationNbr) {
                awardeestore.confirmationId = res.data.confirmationNbr;
                 awardeestore.completedSteps.reviewAndSubmit=true;
                this.props.history.push('/confirmation');
            } else {
                awardeestore.incrementSubmissionErrorCount();
                awardeestore.openErrorModal();
            }
            awardeestore.turnOffBlocking();
        }).catch(error => {
            awardeestore.incrementSubmissionErrorCount();
            awardeestore.openErrorModal();
            awardeestore.turnOffBlocking();
        })
    }

    componentDidMount() {
		window.onpopstate = () => {
			this.props.history.go(1);
		}
	}

    goBack = () => {
		this.setState({ redirectToAcknowledgements: true });
	}

    onClickEditBtn = (event) => {
        const{name} = event.target;
        this.setState({redirectPage: `/${name}`});
    }

    closeModal = () => {
        awardeestore.closeErrorModal();
    }

    openModal = () => {
        awardeestore.openErrorModal();
    }

    onClickErroBtnOk = () => {
        const { history } = this.props;
        if(awardeestore.submissionErrorCount >= awardeestore.definedErrorCount) {
            history.push('/');
            window.location.reload();
        }
        awardeestore.closeErrorModal();
    }

    render() {

        const{redirectToAcknowledgements, redirectPage} = this.state;
        const{showErrorModal, submissionErrorCount} = awardeestore

        const{initialValueObj} = awardeestore.getIndividualInititalValues();

        if(redirectPage && redirectPage.trim().length > 0) {
            return <Redirect to={{pathname: redirectPage, state: {fromReviewAndSubmitPage: true}}}/>
        }

        if (redirectToAcknowledgements) {
			return <Redirect to='/acknowledgements' />
		}

        const {
			awardeeHousingPages,
            definedErrorCount
		} = awardeestore;

        const iframeStyle = {
            height: "0px",
            width: "0px",
            position: "absolute"
        }

        return(
            <div className='border-form'>
                <Modal className="errorModal" isOpen={showErrorModal} toggle={this.onClickErroBtnOk}>
                    <Card>
                        <CardHeader className="errorPopup d-flex justify-content-center flex-column align-items-center center-text">
                        <>
                            <h5>
                                <b>
                                    The  assessment has failed to send.
                                </b>
                            </h5>
                            <div className="spacer" />
                            {submissionErrorCount >= definedErrorCount ? <h6>Please try again sometime later.</h6> : <h6>Hit <b>submit</b> again</h6>}
                            <Button className="errCloseBtn" onClick={this.onClickErroBtnOk} type="button" color="default">
                                OK
                            </Button>
                        </>
                        </CardHeader>
                    </Card>
                </Modal>
                <CustomProgressBar pages={awardeeHousingPages} />                
                <div className='spacer-48' />
                <Form
                    enableReinitialize
                    initialValues={{...initialValueObj}}
                    onSubmit={this.handleSubmit}
                >
                    <span className="no-display reviewAndSubmitContentView">
                        <iframe title="Review_Frame" id="ifmcontentstoprint" style={iframeStyle} />
                        <ReviewSubmitContent />
                    </span>
                    <ReviewSubmitContent onClickEditBtn={this.onClickEditBtn}/>
                    <Row>
                        <Col>
                            <Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack mb-50'} onClick={this.goBack}>
                                Back
                            </Button>
                        </Col>
                        <Col>
                            <div className="d-flex flex-row justify-content-end">
                                <Button type="button" color="link" className="btn btn-link printBtn" onClick={this.printPage}>
                                    <i className="icon icon-print" />
                                    Print Assessment
                                </Button>
                                <Button type="Submit" color="primary" className="btn btn-primary awardeeNextBtn">
                                    Submit
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <div className="mb-50"/>
                </Form>
            </div>
        )
    }
}

ReviewAndSubmit.propTypes = {
	history: PropTypes.object
}